<mat-card fxLayoutGap class="p-3">
  <div class="fw-semibold fs-4">Esporta Dati Iscrizioni</div>
  <div class="v-spacer"></div>
  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    <div class="d-flex flex-row w-100 gap-3">
      <div class="col">
        <app-dea-label class="mb-2" [label]="'Sede:'"></app-dea-label>
        <input type="text" class="form-control dea-form-input" [value]="headquarter" disabled />
      </div>
      <div class="col">
        <app-dea-label class="mb-2" [label]="'Anno Scolastico:'"></app-dea-label>
        <select class="form-select" formControlName="y">
          <option *ngFor="let scholasticYear of scholasticYearsListing;" value="{{scholasticYear}}">
            {{scholasticYear}}
          </option>
        </select>
      </div>
    </div>
    <div class="w-100">
      <app-dea-label class="mb-2" [label]="'Anno:'"></app-dea-label>
      <div class="d-flex flex-row justify-content-start flex-wrap gap-2">
        <div formArrayName="years" *ngFor="let year of yearsListing; let i = index">
          <mat-checkbox [formControlName]="i" color="primary" [labelPosition]="'after'">
            <div class="no-warp">{{ year }}</div>
          </mat-checkbox>
        </div>
      </div>
    </div>
    <div class="w-100">
      <app-dea-label class="mb-2" [label]="'Dipartimenti:'"></app-dea-label>
      <div class="d-flex flex-row justify-content-start flex-wrap gap-2">
        <div formArrayName="departments" *ngFor="let department of departmentsListing; let i = index">
          <mat-checkbox [formControlName]="i" color="primary" [labelPosition]="'after'">
            <div class="no-warp">{{ department }}</div>
          </mat-checkbox>
        </div>
      </div>
    </div>
    <div class="w-100">
      <app-dea-label class="mb-2" [label]="'Tipi di Utenti:'"></app-dea-label>
      <div class="d-flex flex-row justify-content-start flex-wrap gap-2">
        <div formArrayName="types" *ngFor="let userType of userTypesListing; let i = index">
          <mat-checkbox [formControlName]="i" color="primary" [labelPosition]="'after'">
            <div class="no-warp">{{ userType.title }}</div>
          </mat-checkbox>
        </div>
      </div>
    </div>
  </form>
  <div class="m-0 p-0 mt-3 gap-2" mat-dialog-actions align="end">
    <button class="px-5 py-1" mat-stroked-button (click)="onDismiss()" [disabled]="loading">Annulla</button>
    <button class="px-5 py-1" mat-flat-button color="primary" (click)="onConfirm()" [disabled]="loading">
      {{loading?'Esportazione':'Esporta'}} <mat-icon *ngIf="loading">
        <mat-spinner diameter="18"></mat-spinner>
      </mat-icon>
    </button>
  </div>
</mat-card>
